<template>
  <div>
      <ListagemGrupoRotaComponent />
  </div>
</template>

<script>

import ListagemGrupoRotaComponent from '../components/ListagemGrupoRotaComponent.vue';

export default {
  components: { ListagemGrupoRotaComponent },
  name: 'GrupoRotaPage'
}
</script>
